import {useMemo} from 'react';

import {Skeleton} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {VoucherIcon} from 'assets/icons/VoucherIcon';
import {useAppSelector} from 'hooks';
import {BasketLineItem} from 'types';
import {formatPrice} from 'utils';

import {VoucherPriceTagDetail} from './styles';

export type ProductVoucherProps = {
  basketItem: BasketLineItem;
};

export const ProductVoucher = (props: ProductVoucherProps) => {
  const {basketItem} = props;
  const {t} = useTranslation();
  const basketVouchers = useAppSelector((state) => state.basket.basketVouchers);

  const isLoading = !basketVouchers;
  const basketVoucher = useMemo(() => {
    if (!basketVouchers) {
      return;
    }
    const selectedVoucher = basketVouchers.selected.find((v) => v.skus.includes(basketItem.productDetails.sku));
    if (selectedVoucher) {
      return selectedVoucher;
    }
    const unselectedVoucher = basketVouchers.unselected.find((v) => v.skus.includes(basketItem.productDetails.sku));
    return unselectedVoucher;
  }, [basketItem.productDetails.sku, basketVouchers]);

  const onClickVoucher = () => {
    console.log('voucher clicked');
  };

  if (!basketVoucher) {
    return null;
  }

  const voucherUnitPrice = basketItem.productDetails.originPrice - basketVoucher.discount;
  const voucherPoint = basketVoucher.points ?? '??';

  if (isLoading) {
    return <Skeleton animation="wave" variant="rounded" width={120} height={20} />;
  }

  return (
    <VoucherPriceTagDetail onClick={onClickVoucher}>
      <VoucherIcon size={11} />
      {t('voucher.priceTagInfo', {price: formatPrice(voucherUnitPrice), point: voucherPoint})}
    </VoucherPriceTagDetail>
  );
};
